import {
  string as yupString,
  number as yupNumber,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, integer, uniqueWith } from '../../shared/forms/validators';
import { decimalWithSignFormatter } from '../../shared/helpers';

const schema = [
  {
    name: 'fromCurrency',
    component: SelectFormik,
    meta: { label: 'From Currency', optionsKey: 'currencyOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, uniqueWith(['toCurrency'], 'Combination of From Currency and To Currency already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'toCurrency',
    component: SelectFormik,
    meta: { label: 'To Currency', optionsKey: 'currencyOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, uniqueWith(['fromCurrency'], 'Combination of From Currency and To Currency already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'openSpotRate',
    component: InputFormik,
    meta: { label: 'Open Spot Rate' },
    options: { yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true, type: 'number', step: '0.000001', valueFormatter: decimalWithSignFormatter },
  },
  {
    name: 'endSpotRate',
    component: InputFormik,
    meta: { label: 'End Spot Rate' },
    options: { yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true, type: 'number', step: '0.000001', valueFormatter: decimalWithSignFormatter },
  },
  {
    name: 'monthlyOperatingRate',
    component: InputFormik,
    meta: { label: 'Monthly Operating Rate' },
    options: { yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true, type: 'number', step: '0.000001', valueFormatter: decimalWithSignFormatter },
  },
  {
    name: 'weightedAverageRate',
    component: InputFormik,
    meta: { label: 'Weighted Average Rate' },
    options: { yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true, type: 'number', step: '0.000001', valueFormatter: decimalWithSignFormatter },
  },
  {
    name: 'fromCurrencyPrecision',
    component: InputFormik,
    meta: { label: 'From Currency Precision' },
    options: { yupType: yupNumber(), validationRules: [required, integer] },
    additionalProps: { required: true, type: 'number', step: '1' },
  },
  {
    name: 'toCurrencyPrecision',
    component: InputFormik,
    meta: { label: 'To Currency Precision' },
    options: { yupType: yupNumber(), validationRules: [required, integer] },
    additionalProps: { required: true, type: 'number', step: '1' },
  },
];

export default schema;
